import React from 'react';

export interface DashboardSectionProps {
  show: boolean;
  children: React.ReactNode;
  /** Optional one-line teaser when hidden (progressive disclosure hint). */
  teaser?: React.ReactNode;
  className?: string;
}

const DashboardSection: React.FC<DashboardSectionProps> = ({
  show,
  children,
  teaser,
  className = '',
}) => {
  if (show) {
    return <div className={className}>{children}</div>;
  }
  if (teaser) {
    return (
      <div className={`rounded-md border border-dashed border-border bg-surface p-4 text-sm text-fg-muted ${className}`.trim()}>
        {teaser}
      </div>
    );
  }
  return null;
};

export default DashboardSection;
